import { View } from "@/components/ui";
import { Checkbox } from "@/components/ui/checkbox";
import { Controller, useFormContext } from "react-hook-form";
import type { ContactFormData } from "@/store/auth/forms/useContactForm";
import { Typography } from "@/components/shared/typography";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { WarningCircle } from "@/components/shared/icons";

interface PrimaryContactCheckboxProps {
  showTooltip?: boolean;
}

export const PrimaryAccountCheckbox = ({
  showTooltip = false,
}: PrimaryContactCheckboxProps) => {
  const { control } = useFormContext<ContactFormData>();
  return (
    <Controller
      name="primary"
      control={control}
      render={({ field }) => (
        <View className="native:hidden mt-6 flex flex-col gap-3">
          <View className="flex flex-row items-center gap-3">
            <Checkbox
              checked={!!field.value}
              onCheckedChange={(checked) => {
                field.onChange(checked);
              }}
              className="size-6"
              disabled={showTooltip}
            />
            <Typography variant="body-sm" color="muted-foreground">
              Make this my default contact
            </Typography>
            {showTooltip && <Tooltip />}
          </View>
        </View>
      )}
    />
  );
};

const Tooltip = () => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <View className="cursor-pointer">
          <WarningCircle className="scale-y-[-1] transform" />
        </View>
      </DropdownMenuTrigger>

      <DropdownMenuContent className="-left-10 p-2 px-3">
        <View className="max-w-[311px]">
          <Typography variant="body-md">
            To remove this as your primary contact, please select another one
            first.
          </Typography>
        </View>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
